

















import { namespace } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import CustomSelect from '@/common/CustomSelect.vue';
import PreOrderSection from '@/cart-page/PreOrderSection.vue';
import DeliverySlotRow from '@/cart-page/delivery/inputs/DeliverySlotRow.vue';
import AddressAndUnloadingAreaRow from '@/cart-page/delivery/inputs/AddressAndUnloadingAreaRow.vue';
import CartSummaryHeader from '@/cart-page/delivery/inputs/CartSummaryHeader.vue';
import CustomerInformationRow from '@/cart-page/delivery/inputs/CustomerInformationRow.vue';
import NotesRow from '@/cart-page/delivery/inputs/NotesRow.vue';
import CustomerOrderIdRow from '@/cart-page/delivery/inputs/CustomerOrderIdRow.vue';
import MatomoPageVisit from '@/matomo/MatomoPageVisit';
import {
  Step,
  Steps
} from '@/cart-page/header/Step';

const cart = namespace(CART);

@Component({
  components: {
    NotesRow,
    CustomerInformationRow,
    CartSummaryHeader,
    AddressAndUnloadingAreaRow,
    DeliverySlotRow,
    CustomerOrderIdRow,
    PreOrderSection,
    CustomSelect
  }
})
export default class DeliveryStepView extends Vue {
  @Prop({required: false, default: 'de'})
  public locale: string;

  public mounted() {
    MatomoPageVisit.withDocumentTitle(this.$t(Steps.getName(Step.DELIVERY)).toString()).publishPageVisit();
  }
}
